import React, { useContext, useEffect, useState } from "react";
import { MainContainer, StyledDashboard } from "./dashboard.style";
import Stats from "./fixelStats/Stats";

import FixelDataContext from "../../context/FixelDataContext";
import Notifications from "./notifications/Notifications";
import { Link } from "react-router-dom";
import Audiences from "./FBAudiences/Audiences";
import RatingModal from '../rating/RatingModal';

const Dashboard = () => {

  const { fullFixelData } = useContext(FixelDataContext);
  const [haveData, setHaveData] = useState(false);
  const [shouldShowRatingPopup, setShouldShowRatingPopup] = useState(false);

  const showRatingPopup = () => {
    if(window?.fxl_env?.ratingObj.rating){
      setShouldShowRatingPopup(false);
    }
    let weekAgo = new Date();
    weekAgo.setDate(weekAgo.getDate() - 7);
    // On first entrance after the segment is set to active
    const gotActive = fullFixelData && fullFixelData.state === 'active' && fullFixelData.code !== localStorage.getItem('finishedRating');
    // a week after popup closed not finished rating
    const showAgainAfterDismiss = fullFixelData && fullFixelData.state === 'active' && +weekAgo > +localStorage.getItem('rateLaterTimestamp');
    const shouldShow = (gotActive && !localStorage.getItem('rateLaterTimestamp')) || showAgainAfterDismiss;
    setShouldShowRatingPopup(shouldShow);
  };

  useEffect(() => {
    let didCancel = false;
    const showDashboard = () => {
      if (!didCancel && fullFixelData && fullFixelData.code) {
        setHaveData(true);
      }
    };
    showDashboard();
    showRatingPopup();
    return () => {
      didCancel = true;
    };
  }, [fullFixelData]);

  const renderDashboard = () => {
    if (!haveData) {
      return (
        <p>
          no data to show here yet. you can try to go back to the
          <Link to="/introduction"> installation page</Link>
        </p>
      );
    } else {
      return (
        <MainContainer>
          <Notifications />
          <Stats />
          <Audiences />
        </MainContainer>
      );
    }
  };

  return (
    <StyledDashboard>
      {shouldShowRatingPopup ? <RatingModal /> : null}
      <MainContainer>{renderDashboard()}</MainContainer>
    </StyledDashboard>
  );
};
export default Dashboard;
